export default __webpack_public_path__ + "static/media/ais_top_logo@3x.53bfb540.webp";